import JoinEventContainer from './JoinEvent.container';

export default JoinEventContainer;
